import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { editionTitle } from '../../changelogAdminConfig';

// Só o navegador lembra o último endereço: a prévia não depende do usuário logado
const LAST_TO_KEY = 'changelog.previewTo';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const readLastTo = () => {
  try { return localStorage.getItem(LAST_TO_KEY) || ''; } catch { return ''; }
};

/**
 * Para qual e-mail vai a prévia do envio (digitado na hora, lembrado neste navegador).
 * Também usado pelos e-mails de acompanhamento, que passam o subtitle no lugar da edição.
 * @param {{ edition?: Object|null, subtitle?: string, open: boolean, onClose: Function, onSubmit: Function }} props - onSubmit(email)
 */
function SendPreviewDialog({ edition = null, subtitle, open, onClose, onSubmit }) {
  const [to, setTo] = useState('');

  useEffect(() => { if (open) setTo(readLastTo()); }, [open]);

  const value = to.trim();
  const valid = EMAIL_RE.test(value);

  const submit = () => {
    if (!valid) return;
    try { localStorage.setItem(LAST_TO_KEY, value); } catch { /* sem localStorage: só não lembra */ }
    onSubmit(value);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="caption" color="text.secondary" component="div">{subtitle ?? editionTitle(edition)}</Typography>
        <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600 }}>Enviar prévia</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          autoFocus
          fullWidth
          size="small"
          type="email"
          label="E-mail"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
        />
        <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 1 }}>
          Chega com &quot;[Prévia]&quot; e a hora no assunto. O link de descadastro da prévia não descadastra ninguém.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3 }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" disabled={!valid} onClick={submit}>Enviar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SendPreviewDialog;
